(function () {
  if (window.__iwOtoCountdownStarted) return;
  window.__iwOtoCountdownStarted = true;

  var configEl = document.querySelector('[data-iw-oto-countdown-config]');
  if (!configEl) return;

  var minutes = parseInt(configEl.getAttribute('data-timer-minutes'), 10);
  var seconds = parseInt(configEl.getAttribute('data-timer-seconds'), 10);

  if (isNaN(minutes) || minutes < 0) minutes = 5;
  if (isNaN(seconds) || seconds < 0) seconds = 0;

  var totalSeconds = minutes * 60 + seconds;
  if (totalSeconds <= 0) totalSeconds = 5 * 60;

  var remaining = totalSeconds;
  var intervalId = null;

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function render() {
    var mins = Math.floor(remaining / 60);
    var secs = remaining % 60;
    var minText = pad(mins);
    var secText = pad(secs);

    document.querySelectorAll('[data-iw-oto-minutes]').forEach(function (el) {
      el.textContent = minText;
    });

    document.querySelectorAll('[data-iw-oto-seconds]').forEach(function (el) {
      el.textContent = secText;
    });
  }

  function resetTimer() {
    remaining = totalSeconds;
    render();
  }

  function tick() {
    if (remaining <= 0) {
      resetTimer();
      return;
    }

    remaining -= 1;
    render();
  }

  render();
  intervalId = setInterval(tick, 1000);
})();
